var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"isLoadingTipComponents tc"},[_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v(" "+_vm._s(_vm.text ? _vm.text : _vm.$t("loadingIng")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }